import { Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicField } from '@shared/components/dynamic-form/models/field';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';

@Component({
  selector: 'app-free-text-field',
  imports: [SafeHtmlPipe, TranslateModule],
  templateUrl: './free-text-field.component.html',
})
export class FreeTextFieldComponent {
  field = input.required<DynamicField>();
  form = input.required<FormGroup>();
}
